module.exports = __webpack_public_path__ + "static/media/herbs-bundle.e02bcec1.svg";